export default __webpack_public_path__ + "LeslieHUE.f61eed1.png";